import FormConfigurator from '../components/fieldtypes/FormConfigurator.vue';
 
// Should be named [snake_case_handle]-fieldtype
Statamic.$components.register('form_configurator-fieldtype', FormConfigurator);